module.exports = __webpack_public_path__ + "static/media/Network_Workspace_Class_Import_Template.f6eb08bd.xlsx";